'use strict';

var UserFareExclusionRulesController = function UserFareExclusionRulesController($scope, dataRetrieverService, userFareExclusionRulesService, dataRetrieverConstantsService) {
  dataRetrieverService.getDataRetriever('SYSTEM_STATUS_SCREEN', dataRetrieverConstantsService.SYSTEM_STATUS_USER_FO_FARE_EXCLUSION_RULES_MODE).setCustomSearchCriteriaRules([]);
  $scope.makeExportToCsv = function (data) {
    userFareExclusionRulesService.exportToCsv(data);
  };
  $scope.customRemove = function (rowsToBeRemovedFromServer) {
    userFareExclusionRulesService.remove(rowsToBeRemovedFromServer);
  };
  $scope.customSave = function (editedRows) {
    return userFareExclusionRulesService.save(editedRows);
  };
  $scope.customSaveValidation = function (editedRows, gridData) {
    return userFareExclusionRulesService.validate(editedRows, gridData);
  };
};
UserFareExclusionRulesController.$inject = ['$scope', 'DataRetrieverService', 'UserFareExclusionRulesService', 'DataRetrieverConstantsService'];
module.exports = UserFareExclusionRulesController;